export const meetupDate = '2026-02-26';
export const meetupStartTime = '13:00';
export const timeZone = 'CET';
export const formName = 'europe-digital-sovereignty-2026-hamburg';
export const logoUrl = 'https://andersenlab.com/?utm_source=sovereignty_hamburg&utm_medium=event';

export const initialCoordinates = {
  lat: 53.543561,
  lng: 9.941856,
};

export const markerSettings = {
  position: initialCoordinates,
  icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/forum-bishkek/location/marker-for-map.svg',
  title: 'Europe: Digital Sovereignty or Dependence?',
  address: 'Hafen Location Hamburg<br>Van-der-Smissen-Straße 1, 22767 Hamburg',
  link: 'https://maps.app.goo.gl/dJ5pFG8Y3MdPRGVi9',
};
